import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "swiper/swiper.min.css"
// import 'swiper/css/swiper.css'
// import 'swiper/dist/css/swiper.css'
import '@/styles/font.css'
import '@/styles/index.css'
import '@/styles/about.css'
// import '@/styles/public.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper' 
// import swip from 'swiper/dist/css/swiper.css' 
// import 'swiper/dist/css/swiper.css'
import 'swiper/css/swiper.css'
import animate from 'animate.css' // npm install animate.css --save安装，在引入
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'

Vue.use(BaiduMap, {
	ak:'oW2UEhdth2tRbEE4FUpF9E5YVDCIPYih' 
})
Vue.use(animate)
Vue.use(axios)
Vue.config.productionTip = false;
// Vue.use(VueAwesomeSwiper)

new Vue({
	router,
	store,
	render: (h) => h(App),
	mounted() {
        document.dispatchEvent(new Event('render-event'))
		//document.dispatchEvent(new Event('custom-render-trigger')) #这里是重点
    },
}).$mount("#app");

// title

// title
